import moment from 'moment';

export const changeOfTenancySchema = {
  title: 'Start Change Of Tenancy',
  type: 'object',
  properties: {
    moveOutDate: {
      type: 'string',
      title: 'Change of Tenancy Date',
      default: moment().format('YYYY-MM-DD'),
    },
    businessPartner: {
      type: 'string',
      title: 'Business Partner',
      default: null,
    },
    reading: {
      type: 'object',
    },
    customerType: {
      type: 'string',
      title: 'Customer Type',
      enum: ['Private', 'Company'],
      enumNames: ['Private', 'Company'],
    },
    firstName: {
      type: 'string',
      title: 'First Name',
    },
    lastName: {
      type: 'string',
      title: 'Last Name',
    },
    email: {
      type: 'string',
      title: 'email',
    },
    phone: {
      type: 'string',
      title: 'Phone',
    },
  },
  dependencies: {
    customerType: {
      oneOf: [
        {
          properties: {
            customerType: {
              enum: ['Company'],
            },
            companyName: {
              type: 'string',
              title: 'Company Name',
            },
          },
        },
      ],
    },
  },
};

export const changeOfTenancyUISchema = {
  businessPartner: {
    'ui:placeholder': 'Select Customer',
  },
  moveOutDate: {
    'ui:widget': 'date',
  },
  reading: {
    'ui:field': 'readingField',
  },
  'ui:order': [
    'businessPartner',
    'moveOutDate',
    'reading',
    'customerType',
    'companyName',
    'firstName',
    'lastName',
    'email',
    'phone',
  ],
};
